var screenWidth = window.innerWidth;
console.log("Screen width: " + screenWidth + " pixels");
if (screenWidth < 750 ) {
  class StaticPage extends HTMLElement {
    constructor() {
      super();
      const _thisTitle = this.querySelector(".main-page-title");

      this.querySelectorAll(".nav_side li").forEach((btn) => {
        btn.addEventListener("click", (event) => {
          event.preventDefault();

          console.log("clicked")
          let tag = btn.querySelector("a").innerHTML.toLowerCase().replace(/,/g, '').replace(/&amp;/g, '').replace(/;/g, '').replace(/\s+/g, '_');
          let nav = this.querySelector(".nav_side");
          if(nav) {
            nav.classList.add('hidden');
            _thisTitle.classList.add('hidden');
          }
          
          let content = this.querySelector(".content_side")
          let divWithId = content.querySelectorAll("div[id]");
          divWithId.forEach((div) => {
            if(div.id == tag){
              div.querySelector("span").classList.remove("hidden");
              div.querySelector("h2").style.display="inline";
              div.style.display='block';
              div.classList.remove('small-hide');
              
              if(tag === "introduction"){
                let mobile_intro = div.querySelector(".mobile_introduction");
                mobile_intro.style.display="block";
                mobile_intro.classList.remove("hidden");
              }
            }
            else {
              div.style.display='none';
            }

            div.querySelector(".return_arrow")?.addEventListener("click",(event) => {
              event.preventDefault();
              nav.classList.remove('hidden');
              div.classList.add('small-hide');
            });
          });
          
          window.scrollTo({top: 10, behavior: 'smooth'});
          
          })
        });

    }
  
  }
  customElements.define('static-page', StaticPage);
}